import GET_STORE from './queries/GET_STORE';
import IS_LOGIN from './queries/IS_LOGIN';
export default (cache) => {
    cache.writeQuery({
        query: IS_LOGIN,
        data: {
            isLoggedIn: !!localStorage.getItem('token'),
        },
    });
    cache.writeQuery({
        query: GET_STORE,
        data: {
            isFilterbarVisible: false,
            isAttachmentVisible: true,
        },
    });
};
